import React from 'react';

import IMG_1 from '../assets/images/online_class/online-learning.svg';
import IMG_2 from '../assets/images/online_class/video.svg';
import IMG_3 from '../assets/images/online_class/book2.svg';
import IMG_4 from '../assets/images/online_class/monitor.svg';
import IMG_5 from '../assets/images/online_class/board.svg';
import IMG_6 from '../assets/images/online_class/projector.svg';
import IMG_7 from '../assets/images/online_class/laptop.svg';
import IMG_8 from '../assets/images/online_class/web.svg';

import IntroVideo from '../assets/intro2.mp4';



export const Content40DataSource = {
  wrapper: { className: 'home-page-wrapper content4-wrapper' },
  page: { className: 'home-page content4' },
  OverPack: { playScale: 0.3, className: '', always:false },
  titleWrapper: {
    className: 'page-title',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>سامانه برگزاری کلاس و جلسات آنلاین</p>
          </span>
        ),
        className: '',
      },
      {
        name: 'content',
        className: 'page-subtitle',
        children: (
          <span>
            <p>
              مدتاک با ارائه&nbsp; پلتفرم کلاس آنلاین خود بستری امن برای
              برگزاری&nbsp; انواع کلاس آنلاین، دوره های آموزشی مجازی، جلسات
              آنلاین سازمانی، نشست‌های تخصصی و همچنین برگزاری ویدئو کنفرانس‌ها و
              سمینارهای وبی که با نام وبینار شناخته شده‌اند، بوجود آورده است.
              مهم ترین نکته در انتخاب مدتاک امنیت و عدم قطعی سرویس ها می‌باشد که
              مدتاک با استفاده از مسیردهی هوشمند کلاس های در حال برگزاری بر روی
              سرور های خود کوشیده است تا بیشترین رضایت را در میان پلتفرم های
              مشابه داشته باشد.
            </p>
          </span>
        ),
      },
    ],
  },
  video: {
    className: 'content4-video',
    children: {
      video: IntroVideo,
      image: 'https://zos.alipayobjects.com/rmsportal/HZgzhugQZkqUwBVeNyfz.jpg',
    },
  },
};
export const Feature60DataSource = {
  wrapper: { className: 'home-page-wrapper feature6-wrapper' },
  OverPack: { className: 'home-page feature6', playScale: 0.3, always: false },
  Carousel: {
    className: 'feature6-content',
    dots: false,
    wrapper: { className: 'feature6-content-wrapper' },
    titleWrapper: {
      className: 'feature6-title-wrapper',
      barWrapper: {
        className: 'feature6-title-bar-wrapper',
        children: { className: 'feature6-title-bar' },
      },
      title: { className: 'feature6-title' },
    },
    children: [
      {
        title: {
          className: 'feature6-title-text',
          children: (
            <span>
              <p>مدتاک؛ مورد اعتماد شما</p>
            </span>
          ),
        },
        className: 'feature6-item',
        name: 'block0',
        children: [
          {
            md: 8,
            xs: 24,
            className: 'feature6-number-wrapper',
            name: 'child0',
            number: {
              className: 'feature6-number',
              unit: {
                className: 'feature6-unit',
                children: (
                  <span>
                    <span>
                      <p>
                        <br />
                      </p>
                    </span>
                  </span>
                ),
              },
              toText: true,
              children: '5430',
            },
            children: {
              className: 'feature6-text',
              children: (
                <span>
                  <p>تعداد ساعات برگزاری کلاس و جلسه</p>
                </span>
              ),
            },
          },
          {
            md: 8,
            xs: 24,
            className: 'feature6-number-wrapper',
            name: 'child1',
            number: {
              className: 'feature6-number',
              unit: {
                className: 'feature6-unit',
                children: (
                  <span>
                    <span>
                      <span>
                        <p>
                          <br />
                        </p>
                      </span>
                    </span>
                  </span>
                ),
              },
              toText: true,
              children: '1265',
            },
            children: {
              className: 'feature6-text',
              children: (
                <span>
                  <p>تعداد کل جلسات</p>
                </span>
              ),
            },
          },
          {
            md: 8,
            xs: 24,
            className: 'feature6-number-wrapper',
            name: 'child2',
            number: {
              className: 'feature6-number',
              unit: {
                className: 'feature6-unit',
                children: (
                  <span>
                    <p>
                      <br />
                    </p>
                  </span>
                ),
              },
              toText: true,
              children: '126',
            },
            children: {
              className: 'feature6-text',
              children: (
                <span>
                  <p>تعداد جلسات درحال برگزاری</p>
                </span>
              ),
            },
          },
        ],
      },
    ],
  },
};
export const Feature70DataSource = {
  wrapper: { className: 'home-page-wrapper feature7-wrapper' },
  page: { className: 'home-page feature7' },
  OverPack: { playScale: 0.3, always:false },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        className: 'title-h1',
        children: (
          <span>
            <p>امکانات</p>
          </span>
        ),
      },
    ],
  },
  blockWrapper: {
    className: 'feature7-block-wrapper',
    gutter: 24,
    children: [
      {
        md: 6,
        xs: 24,
        name: 'block0',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'image',
              className: 'feature7-block-image',
              children: IMG_1,
            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: (
                  <p>ارتباط شنیداری و دیداری</p>
              ),
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: (
                    <p>
                      امکان برقراری ارتباط صوتی ، تصویری و نوشتاری برای همه اعضا
                      چه برگزارکننده و چه شرکت کننده
                    </p>
              ),
            },
          ],
        },
      },
      {
        md: 6,
        xs: 24,
        name: 'block1',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'image',
              className: 'feature7-block-image',
              children:IMG_2,
            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: (
                  <p>اشتراک دسکتاپ</p>
              ),
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: (
                    <p>به اشتراک گذاشتن محیط دسکتاپ، نرم‌افزار و صفحات وب</p>
              ),
            },
          ],
        },
      },
      {
        md: 6,
        xs: 24,
        name: 'block2',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'image',
              className: 'feature7-block-image',
              children: IMG_3,            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: (
                        <p>بدون نیاز به نصب نرم افزار&nbsp;</p>
              ),
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: (
                      <p>
                        نمایش فایل‌های PDF، PowerPoint و عکس به‌صورت اسلاید{' '}
                      </p>
              ),
            },
          ],
        },
      },
      {
        md: 6,
        xs: 24,
        name: 'block3',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'image',
              className: 'feature7-block-image',
              children: IMG_4,
            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: (
                  <p>نمایش اسلاید</p>
              ),
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: (
                      <p>نمایش فایل‌های PDF، PowerPoint و عکس به‌صورت اسلاید</p>
              ),
            },
          ],
        },
      },
      {
        md: 6,
        xs: 24,
        name: 'block4',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'image',
              className: 'feature7-block-image',
              children:IMG_5,
            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: (
                  <p>وایت‌برد</p>
              ),
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: (
                    <p>تخته مجازی جهت یادداشت نویسی و رسم اشکال هندسی</p>
              ),
            },
          ],
        },
      },
      {
        md: 6,
        xs: 24,
        name: 'block5',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'image',
              className: 'feature7-block-image',
              children:IMG_6,
            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: (
                  <p>ضبط صوت و تصویر</p>
              ),
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: (
                  <p>دسترسی به محتوای ضبط شده ی کلاس پس از پایان کلاس آموزشی</p>
              ),
            },
          ],
        },
      },
      {
        md: 6,
        xs: 24,
        name: 'block6',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'image',
              className: 'feature7-block-image',
              children:IMG_7,
            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: (
                    <p>ایجاد نظر سنجی</p>
              ),
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: (
                    <p>برگزاری نظرسنجی و آزمونک های کلاسی</p>
              ),
            },
          ],
        },
      },
      {
        md: 6,
        xs: 24,
        name: 'block7',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'image',
              className: 'feature7-block-image',
              children:IMG_8,
            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: (
                    <p>نمایش لیست حاضران</p>
              ),
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: (
                  <p>لیست شرکت کنندگان در کلاس های آموزشی، حضورغیاب و ...</p>
              ),
            },
          ],
        },
      },
    ],
  },
};
